export default "__VITE_PUBLIC_ASSET__1e64facd__"